// hooks/useTourGroupEditingState.ts
import { useEffect, useState } from "react";
import io from "socket.io-client";
import { useAxios } from "@/axiosProvider";
import { useFetchTourGroupById } from "@/reactQueryHooks";

//------------------------------------------------------------

const serverSocket = io("https://getaways-bookings.herokuapp.com", {
  transports: ["websocket"],
});

// const serverSocket = io("http://localhost:4000", {
//   transports: ["websocket"],
// });

const useTourGroupEditingState = (tour_group_id: string) => {
  const { user } = useAxios();
  const [isEditing, setIsEditing] = useState(false);
  const [editingUserId, setEditingUserId] = useState<string | null>(null);

  const { refetch } = useFetchTourGroupById(tour_group_id);

  useEffect(() => {
    const handleEditing = (payload: { user_id: string }) => {
      setEditingUserId(payload.user_id);
      if (payload.user_id !== user._id) {
        setIsEditing(true);
      }
    };

    const handleClosedEditing = (payload: { user_id: string }) => {
      setEditingUserId(null);
      setIsEditing(false);
      refetch();
    };

    serverSocket.on(
      `getaways_suite/tour_group_opened_editing/${tour_group_id}`,
      handleEditing
    );
    serverSocket.on(
      `getaways_suite/tour_group_closed_editing/${tour_group_id}`,
      handleClosedEditing
    );

    return () => {
      serverSocket.off(
        `getaways_suite/tour_group_opened_editing/${tour_group_id}`,
        handleEditing
      );
      serverSocket.off(
        `getaways_suite/tour_group_closed_editing/${tour_group_id}`,
        handleClosedEditing
      );
    };
  }, [tour_group_id, user._id, refetch]);

  return { isEditing, editingUserId };
};

export default useTourGroupEditingState;
